import React from 'react';

const Footer = props => (
    <footer className="footer-section">
        <div className="container">
            <div className="row py-2">
                <div className="col-12 col-md-5 col-lg-4">
                    <h5>
                        <img src="/assets/images/worldcup2018/logo-trueid.svg" className="img-fluid align-top" alt="TrueID logo" />
                    </h5>
                    <p className="mt-2">
                        <strong className="d-block">YOUR EXTRA-TAINMENT</strong>
                        ทรูไอดี แอปเดียวครบสุด...ทุกความสนุกและสิทธิพิเศษ</p>
                    <p className="app-download-button row">
                        <a href="https://itunes.apple.com/us/app/trueid/id1013814221?ls=1&amp;mt=8" className="col-6">
                        <img src="/assets/images/worldcup2018/button-appstore.svg" className="img-fluid" alt="Download form AppStore" />
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.tdcm.trueidapp" className="col-6">
                        <img src="/assets/images/worldcup2018/button-playstore.svg" className="img-fluid" alt="Download form PlayStore" />
                        </a>
                    </p>
                </div>
                <div className="offset-lg-3 col-12 col-md-7 col-lg-5">
                    <ul className="list-unstyled d-flex justify-content-between my-2 my-md-5 my-lg-5">
                        <li className="d-inline-block text-center">
                        <a href="http://news.trueid.net/detail/90196" id="footer_about">เกี่ยวกับเรา</a>
                        </li>
                        <li className="d-inline-block text-center">
                        <a href="http://news.trueid.net/detail/90198" id="footer_condition">ข้อกำหนดและเงื่อนไข</a>
                        </li>
                        <li className="d-inline-block text-center">
                        <a href="http://news.trueid.net/detail/90202" id="footer_policy">นโยบาย</a>
                        </li>
                        <li className="d-inline-block text-center">
                        <a href="http://news.trueid.net/detail/90196" id="footer_contact">ติดต่อเรา</a>
                        </li>
                    </ul>
                    <div className="d-flex flex-column flex-lg-row">
                        <p className="copy-right">
                        Copyright &copy; True Digital &amp; Media Platform Company Limited. All rights reserved
                        </p>
                        <ul className="list-unstyled d-flex justify-content-center new-footer-social-icons mx-auto ml-lg-auto pl-3">
                            <li className="mx-1">
                                <a href="#">
                                <i className="fab fa-facebook-square fa-2x"></i>
                                </a>
                            </li>
                            <li className="mx-1">
                                <a href="#">
                                <i className="fab fa-twitter-square fa-2x"></i>
                                </a>
                            </li>
                            <li className="mx-1">
                                <a href="#">
                                <i className="fab fa-line fa-2x"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/Footer.js